import React, { Component } from 'react';

export default class EllipsisTitle extends Component {

    shouldComponentUpdate(nextProps) {

        if (nextProps.title != this.props.title
                || nextProps.width != this.props.width
                || nextProps.display != this.props.display) {
            
                    return true;
        }

        return false;
    }

    render(){

        return(
            <span style={{
                    display: this.props.display || 'inline-block',
                    width: this.props.width
                }}
                className='ellipsis' title={this.props.title}>
                {this.props.title}
            </span>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/portal/ellipsisTitle.jsx